import {whenAppears} from "./whenAppears.js";
import VueScrollTo from "vue-scrollto";

export const fcwp_dynamic_data = function(url) {

    whenAppears(".fcwp-data-shortcode", async function(element) {

        var wrapper = element.querySelector('.wrapper');
        var data_table = element.querySelector('.fcwp-table');
        var no_data_div = element.querySelector('.no-data');
        var loader_div = element.querySelector('.data-loader');
        var error_div = element.querySelector('.data-error');
        var navigation_div = element.querySelector('.navigation');
        var back_div = element.querySelector('a.navigate-back');
        var forward_div = element.querySelector('a.navigate-forward');
        var navigation_type = wrapper.getAttribute('navigation');
        var menu_div = element.querySelector('.fcwp-table-form');

        var current_no = 0;
        var data = collectRequest(element);
        var response = await makeRequest(data);

        loader_div.style.position = 'absolute';
        error_div.style.position = 'absolute';

        setView(response);

        forward_div.onclick = forwardClick;
        back_div.onclick = backClick;

        function setView(response) {
            if (response.error) console.log(response.error);
            if (response.no_data === true) {
                show(no_data_div);
                remove(navigation_div);
                return;
            }
            remove(no_data_div);

            if (navigation_type == 'replace') data_table.innerHTML = '';
            if (response.header) setHeader(response.header);

            setTableData(response.table);

            show(data_table);

            setNavigation(response.forward, response.back);

            setMenu(response.menu);
        }

        function setHeader(header_data) {
            if (headerExists()) return;
            var header = createRow('table-header');
            populateRow(header, header_data)
            data_table.appendChild(header);

        }

        function setMenu(items) {
            if (!items) return;
            if (menu_div.innerHTML !== '') return;

            var select_node = document.createElement('select');
            for (var item of items) {
                var option = new Option();
                option.value = item.value;
                option.text = item.name;
                select_node.options.add(option);
            }
            menu_div.appendChild(select_node);

            select_node.onchange = async function(e) {
                var selected_value = select_node.options[select_node.selectedIndex].value;
                data.option = selected_value;
                current_no = 0;
                var response = await makeRequest(data);

                loader_div.style.position = 'absolute';
                error_div.style.position = 'absolute';

                setView(response);
            }
        }

        function headerExists() {
            var header = data_table.querySelector('tr.table-header');
            return (header != null);
        }

        function setTableData(table) {
            var classname;
            var i = data.amount * data.no;
            for (var item of table) {
                classname = i % 2 == 0 ? 'even' : 'odd';
                i++;
                var row = createRow(classname);
                populateRow(row, item);
                data_table.appendChild(row);
            }
        }

        function createRow(classname) {
            var row = document.createElement('tr');
            row.classList.add(classname);
            return row;
        }

        function populateRow(row, data) {
            for (var key in data) {
                var cell = document.createElement('td');
                appendClass(cell, response.classes[key]);
                cell.innerHTML = data[key];
                row.appendChild(cell);
            }
        }

        function appendClass(cell, class_to_add) {
            if (typeof class_to_add == 'undefined' || class_to_add === null) return;
            if (typeof class_to_add == 'string') cell.classList.add(class_to_add);
            if (Array.isArray(class_to_add)) {
                for (var added_class of class_to_add) {
                    cell.classList.add(added_class);
                }
            }
        }

        function setNavigation(forward, back) {
            if (navigation_type == 'append') {
                forward_div.innerHTML = '<i class="fas fa-chevron-right fa-rotate-90"></i>';
                hide(back_div);
            }
            forward === true ? show(forward_div) : hide(forward_div);
            if (navigation_type == 'append') return null;
            back === true ? show(back_div) : hide(back_div);
        }

        function forwardClick(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            current_no++;
            doClick();
        }

        function backClick(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            current_no--;
            doClick();
        }

        async function doClick() {
            // if (navigation_type == 'replace') data_table.innerHTML = '';
            hide(forward_div);
            hide(back_div);
            if (navigation_type == 'replace') hide(data_table);
            response = await makeRequest(data);
            setView(response);
            if (navigation_type == 'append') return
            VueScrollTo.scrollTo(wrapper, 1000, {
                offset: -50,
                easing: "ease"
              });
        }


        function collectRequest() {
            var to_collect = ['type', 'amount'];
            var data = {};
            for (var att of to_collect) {
                data[att] = wrapper.getAttribute(att);
            }
            return data;
        }


        async function makeRequest(data) {
            show(loader_div)
            var api_url = url + '/api/fcwp/v1/fcwp-table/';
            data.no = current_no;
            return axios.get(api_url, {
                params: data
            }).then ( (response) => {
                hide(loader_div);
                return response.data;
            }).catch ((error) => {
                console.log(error);
                show(error_div);
                hide(loader_div);
                return;
            });
        }

        function show(el) {
            el.style.opacity = 1;
            el.style.zIndex = 100;
        }

        function hide(el) {
            el.style.opacity = 0;
            el.style.zIndex = -100;
        }

        function remove(el) {
            el.style.display = 'none';
        }

    });
}